import React from 'react';
import { Can } from '../../../../../_contexts/AbilitiesContext';
import CancelAction from './CancelAction';
import RescheduledAction from './RescheduleAction';

export default function EventViewActions({ event, rescheduling, cancelEvent, rescheduleEvent }) {
  return <div>

    <Can I="reschedule" an="events">
      <RescheduledAction event={event} rescheduling={rescheduling} rescheduleEvent={rescheduleEvent} />
      &nbsp;
    </Can>

    <Can I="cancel" an="events">
      <CancelAction event={event} cancelEvent={cancelEvent} />
    </Can>

  </div>
}